const postsSliderInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-blog-posts .swiper")] : Array.from(document.querySelectorAll('.bn-blog-posts .swiper'));

    const PARTIAL_CLASS = 'swiper-slide--partial';
    const OFF_LEFT_CLASS = 'swiper-slide--off-left';
    const DESKTOP_SHARP = 3;

    const getHorizontalStep = (slidesGrid = []) => {
        if (!Array.isArray(slidesGrid) || slidesGrid.length < 2) {
            return null;
        }

        for (let i = 1; i < slidesGrid.length; i += 1) {
            const diff = Math.round(Math.abs(slidesGrid[i] - slidesGrid[i - 1]));
            if (diff > 0) {
                return diff;
            }
        }

        return null;
    };

    const markPartialSlide = (swiper) => {
        if (!swiper || !swiper.el || !swiper.slides || !swiper.slides.length) {
            return;
        }

        const swRect = swiper.el.getBoundingClientRect();
        const desktop = window.innerWidth >= 1400;
        const step = getHorizontalStep(swiper.slidesGrid);

        swiper.slides.forEach((slide) => {
            const slideRect = slide.getBoundingClientRect();
            let faded;
            let offLeft = false;

            if (desktop && step) {
                const offset = Math.round((slideRect.left - swRect.left) / step);
                const desktopSharp = swiper.params && swiper.params.grid && swiper.params.grid.rows > 1 ? 2 : DESKTOP_SHARP;
                offLeft = offset < 0;
                faded = !offLeft && offset >= desktopSharp;
            } else {
                faded = !(slideRect.left >= swRect.left - 2 && slideRect.right <= swRect.right + 2);
                offLeft = slideRect.right <= swRect.left + 2;
            }

            slide.classList.toggle(PARTIAL_CLASS, faded);
            slide.classList.toggle(OFF_LEFT_CLASS, offLeft);
        });
    };

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const sliderRows = Number.parseInt(slider.dataset.sliderRows || '1', 10) === 2 ? 2 : 1;
                const hasTwoRows = sliderRows === 2;

                if (hasTwoRows && slider.dataset.twoRowSlidesPrepared !== '1') {
                    const wrapper = slider.querySelector(':scope > .swiper-wrapper');
                    const slides = wrapper ? Array.from(wrapper.children).filter((child) => child.classList.contains('swiper-slide')) : [];
                    // No loop here (see sliderConfig.loop below) - the partial-right preview needs one
                    // spare column of real content duplicated past the last real column, otherwise
                    // there's nothing to peek at once the real posts run out.
                    const realColumns = Math.ceil(slides.length / 2);
                    const targetSlides = (realColumns + 1) * 2;

                    if (slides.length) {
                        for (let index = slides.length; index < targetSlides; index += 1) {
                            wrapper.appendChild(slides[index % slides.length].cloneNode(true));
                        }
                    }

                    slider.dataset.twoRowSlidesPrepared = '1';
                }

                let nextEl = slider.parentNode.querySelector(".swiper-button-next");
                let prevEl = slider.parentNode.querySelector(".swiper-button-prev");

                const sliderId = slider.dataset.sliderId;
                if (sliderId) {
                    const externalNavBlocks = document.querySelectorAll(`.bn-blog-posts-nav[data-target-slider-id="${sliderId}"]`);
                    if (externalNavBlocks.length > 0) {
                        nextEl = `.bn-blog-posts-nav[data-target-slider-id="${sliderId}"] .swiper-button-next`;
                        prevEl = `.bn-blog-posts-nav[data-target-slider-id="${sliderId}"] .swiper-button-prev`;
                    }
                }

                const sliderConfig = {
                    observer: true,
                    // With loop:false (2-row sliders, below) markPartialSlide's own classList toggles
                    // never settle if this observer echoes them back into a destroy/reinit loop.
                    observeSlideChildren: !hasTwoRows,
                    // Swiper's Grid (rows>1) + Loop combo periodically recycles a duplicate to the
                    // wrong side, which broke the partial-right preview; 2-row sliders don't loop.
                    loop: !hasTwoRows,
                    loopedSlides: 5,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerGroup: 1,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    grid: {
                        rows: 1,
                        fill: 'row',
                    },
                    pagination: false,
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        // > 450px: two centered slides; below: one. Center mode + 10px gap on mobile.
                        450: {
                            slidesPerView: 1.5,
                            spaceBetween: 10,
                            centeredSlides: true,
                            grid: {
                                rows: 1,
                                fill: 'row',
                            },
                        },
                        // tabletL and up: back to the standard left-aligned layout.
                        992: {
                            slidesPerView: hasTwoRows ? 2 : 2.5,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                            centeredSlides: false,
                            grid: {
                                rows: hasTwoRows ? 2 : 1,
                                fill: 'row',
                            },
                        },
                        1200: {
                            slidesPerView: hasTwoRows ? 2 : 2.5,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                            centeredSlides: false,
                            grid: {
                                rows: hasTwoRows ? 2 : 1,
                                fill: 'row',
                            },
                        },
                        1400: {
                            slidesPerView: hasTwoRows ? 2 : 3,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                            centeredSlides: false,
                            grid: {
                                rows: hasTwoRows ? 2 : 1,
                                fill: 'row',
                            },
                        },
                    }
                }

                const hasPartialRight = slider.closest('.bn-blog-posts--slider-partial-right') !== null;

                if (hasPartialRight) {
                    sliderConfig.on = {
                        init: markPartialSlide,
                        setTranslate: markPartialSlide,
                        transitionEnd: markPartialSlide,
                        slideChange: markPartialSlide,
                        breakpoint: markPartialSlide,
                        loopFix: markPartialSlide,
                    };
                }

                const initSwiper = () => {
                    const instance = new Swiper(slider, sliderConfig);

                    if (!hasPartialRight) {
                        instance.slides.forEach((slide) => {
                            slide.classList.remove(PARTIAL_CLASS);
                            slide.classList.remove(OFF_LEFT_CLASS);
                        });
                    }

                    instance.on('observerUpdate', () => {
                        instance.destroy(true, true);
                        initSwiper();
                    });
                    return instance;
                };

                slider.bnReinit = () => {
                    if (slider.swiper) {
                        slider.swiper.destroy(true, true);
                    }
                    initSwiper();
                };

                initSwiper();
            }
        });
    }
}

const hoverableCardsInit = (scope = document) => {
    const cards = Array.from(scope.querySelectorAll('.bn-blog-posts .cpt-box.--post, .bn-blog-posts .cpt-box.--branze, .bn-blog-posts .cpt-box.--uslugi, .bn-blog-posts .cpt-box.--referencje, .bn-blog-posts .cpt-box.--case-study'));

    cards.forEach((card) => {
        if (card.dataset.cardLinkBound === '1') {
            return;
        }

        const primaryLink = card.querySelector('.cpt-box__header-flex h3 a, .cpt-box__title a, h3 a, .cpt-box__desc--btn');
        if (!primaryLink || !primaryLink.href) {
            return;
        }

        card.dataset.cardLinkBound = '1';
        card.classList.add('is-hoverable');
        card.setAttribute('role', 'link');
        card.setAttribute('tabindex', '0');

        if (!card.getAttribute('aria-label')) {
            const label = primaryLink.textContent ? primaryLink.textContent.trim() : '';
            if (label) {
                card.setAttribute('aria-label', label);
            }
        }

        card.addEventListener('click', (event) => {
            if (event.defaultPrevented) {
                return;
            }

            if (event.target.closest('a, button, input, textarea, select, label, [role="button"]')) {
                return;
            }

            window.location.href = primaryLink.href;
        });

        card.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }

            event.preventDefault();
            window.location.href = primaryLink.href;
        });
    });
};

document.addEventListener("DOMContentLoaded", function () {
    if (document.body && !document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body')) {
        postsSliderInit();
        hoverableCardsInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/blog-posts', (block) => {
            postsSliderInit(block);
            if (block && block[0]) {
                hoverableCardsInit(block[0]);
            }
        });
    }
});
